import React, { Component } from 'react'
import tools from '../../tools'

// Aperçu schématique de la home vacancier (colonne droite des niveaux 1-2 de /contenu).
// Données réelles (titres, ordre, visibilité, icônes, couleurs du thème), rendu simplifié :
// les cartes photo sont figurées par un dégradé du thème, pas par les vraies couvertures.
// Largeur native 375px : à réduire par transform scale dans un cadre téléphone.
class RenderHome extends Component {
	_color = (index) => {
		const theme = this.props.theme
		if (!theme)
			return '#9CA3AF'
		const colors = [theme.color1, theme.color2, theme.color3, theme.color4]
		const color = colors[index % 4]
		return (color) ? '#' + color : '#9CA3AF'
	}

	_groupSection = (module, key) => {
		const title = tools.getTranslationValue(module.translations, this.props.lang, 'title') || module.name
		let cats = []
		for (let i = 0; i < (this.props.categories || []).length; i++)
		{
			if (this.props.categories[i].group === module.values.group)
				cats.push(this.props.categories[i])
		}
		cats.sort((a, b) => {
			return a.order - b.order
		})
		return (
			<div className="mb-5" key={key}>
				<div className="flex justify-between items-baseline px-4 mb-2">
					<p className="font-bold text-gray-900 mb-0" style={{ fontSize: '17px' }}>{title}</p>
					{cats.length > 3 &&
						<span className="text-xs font-semibold" style={{ color: this._color(0) }}>Voir tout ›</span>
					}
				</div>
				<div className="flex px-4" style={{ gap: '8px', overflow: 'hidden' }}>
					{cats.slice(0, 3).map((category, index) => {
						const name = tools.getTranslationValue(category.translations, this.props.lang, 'name')
						const icon = tools.getIconPreview(this.props.icons, category.icon, 'lineal', 'blank')
						return (
							<div key={index} className="rounded-xl flex flex-col items-center justify-center px-1 flex-shrink-0" style={{ backgroundColor: this._color(0), width: '104px', height: '104px' }}>
								{icon && <img src={icon} style={{ width: '34px', opacity: 0.95 }} alt="" />}
								<p className="text-white font-semibold text-center mb-0 mt-1" style={{ fontSize: '11px', lineHeight: 1.2 }}>{name}</p>
							</div>
						)
					})}
					{cats.length === 0 &&
						<p className="text-xs text-gray-300 mb-0 italic">(rubrique vide)</p>
					}
				</div>
			</div>
		)
	}

	_card = (module, key, index) => {
		const translation = tools.getTranslation(module.translations, this.props.lang)
		const title = (translation && translation.title) ? translation.title : module.name
		const subtitle = (translation && translation.values && translation.values.subtitle) ? translation.values.subtitle : null
		return (
			<div key={key} className="mx-4 mb-4 rounded-xl flex flex-col justify-end px-4 py-3" style={{ background: 'linear-gradient(135deg, ' + this._color(index) + ' 0%, ' + this._color(index + 1) + ' 100%)', minHeight: '88px' }}>
				<p className="text-white font-bold mb-0" style={{ fontSize: '15px' }}>{title}</p>
				{subtitle &&
					<p className="mb-0" style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '12px' }}>{subtitle}</p>
				}
			</div>
		)
	}

	_animation = (module, key) => {
		const title = tools.getTranslationValue(module.translations, this.props.lang, 'title') || module.name
		return (
			<div key={key} className="mx-4 mb-4 rounded-xl border border-gray-200 px-4 py-3">
				<p className="font-bold text-gray-900 mb-2" style={{ fontSize: '15px' }}>✦ {title}</p>
				<div className="flex" style={{ gap: '6px' }}>
					<span className="rounded-full bg-gray-100" style={{ width: '72px', height: '14px' }}></span>
					<span className="rounded-full bg-gray-100" style={{ width: '96px', height: '14px' }}></span>
					<span className="rounded-full bg-gray-100" style={{ width: '56px', height: '14px' }}></span>
				</div>
			</div>
		)
	}

	render() {
		let visible = []
		for (let i = 0; i < (this.props.modules || []).length; i++)
		{
			if (this.props.modules[i].hidden !== true)
				visible.push(this.props.modules[i])
		}
		let card_k = -1
		return (
			<div className="bg-white" style={{ width: '375px', fontFamily: 'Nunito, Arial, sans-serif', minHeight: '600px' }}>
				<div className="flex items-end px-4 pb-3" style={{ backgroundColor: this._color(0), height: '80px' }}>
					<p className="text-white font-bold mb-0" style={{ fontSize: '19px' }}>Accueil</p>
				</div>
				<div className="py-4">
					{visible.map((module, index) => {
						if (module.type === "group" && module.values && module.values.group)
							return this._groupSection(module, index)
						if (module.type === "animation")
							return this._animation(module, index)
						card_k++
						return this._card(module, index, card_k)
					})}
					{visible.length === 0 &&
						<p className="text-center text-gray-400 text-sm px-6 py-10 mb-0">Tout le contenu est masqué : l'accueil des vacanciers est vide.</p>
					}
				</div>
			</div>
		)
	}
}

export default RenderHome
